module.exports = __webpack_public_path__ + "static/media/10.92c1cc0b.jpg";